import { Controller } from "@hotwired/stimulus"

// Handles inline form editing that submits via fetch and updates DOM on success.
// Place on each form. Used on software_subscriptions and membership_periods listing pages.
export default class extends Controller {
  static values = { responseSelector: { type: String, default: "#response" } }

  submit(event) {
    event.preventDefault()
    const formData = new FormData(this.element)
    const url = this.element.action
    const method = formData.get('_method') || this.element.method

    fetch(url, {
      method: method.toUpperCase(),
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      const responseEl = document.querySelector(this.responseSelectorValue)
      if (responseEl) responseEl.innerHTML = 'Updated invoice: ' + data.invoice_id

      const btn = this.element.querySelector('.btn')
      if (btn) btn.classList.add('btn-success')

      const statusEl = document.getElementById('status_id_' + data.id)
      if (statusEl) statusEl.innerHTML = data.status
    })
  }
}
